import { Address, ChainKey, makeAddressRecordSync } from "@silo/types";

export {
  siloLensAddress,
  siloRepositoryAddress,
  uniswapV3PriceProviderAddress,
  uniswapV3PriceProviderV2Address,
  priceProvidersRepositoryAddress,
  uniswapV3PriceProviderV3Address,
  balancerV2PriceProviderAddress,
  chainlinkV3PriceProviderAddress,
  wSTETHPriceProviderAddress,
  wSTETHPriceByChainlinkArbitrumAddress,
  wSTETHPriceByChainlinkOptimismAddress,
  gOHMPriceProviderAddress,
  diaPriceProviderV2Address,
  diaPriceProviderV2Y2KAddress,
  forwarderPriceProviderAddress,
  crvUSDViaUSDCPriceProviderETHAddress,
} from "./generated";

/**
 * These are Chainlink ETH/USDs feeds. To add a new chain, look here: https://data.chain.link/feeds
 */
export const chainlinkEthUsdFeedAddress: Record<ChainKey, Address> =
  makeAddressRecordSync({
    ethereum: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419",
    arbitrum: "0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612",
    optimism: "0x13e3Ee699D1909E989722E753853AE30b17e08c5",
    base: "0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70",
    local: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419",
    anvil: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419",
  });

/**
 * Quote token pool
 *
 * These are uniswap WETH/USDC pools. To add a new chain, find the largest pool for that chain using a tool like https://www.geckoterminal.com/.
 *
 * 1) filter by the new chain
 * 2) filter by Uniswap V3 as the DEX
 * 3) sort by liquidity descending, and pick the first WETH-USDC pool
 */
export const uniswapWethUsdcPoolAddress: Record<ChainKey, Address> =
  makeAddressRecordSync({
    ethereum: "0x8ad599c3a0ff1de082011efddc58f1908eb6e6d8",
    arbitrum: "0xc31e54c7a869b9fcbecc14363cf510d1c41fa443",
    optimism: "0x85149247691df622eaf1a8bd0cafd40bc45154a9",
    base: "0xd0b53D9277642d899DF5C87A3966A349A798F224",
    local: "0x8ad599c3a0ff1de082011efddc58f1908eb6e6d8",
    anvil: "0x8ad599c3a0ff1de082011efddc58f1908eb6e6d8",
  });
